import { useEffect, useState } from "react";
import { Alert, Button, Space, Tree } from "antd";
import useAjax from "helpers/ajax";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showSuccess } from "helpers/utility";

const Permissions = () => {
  const { state } = useLocation();
  const { get, post } = useAjax();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);

  const onCheck = (checkedKeysValue) => {
    setCheckedKeys(checkedKeysValue);
  };

  const onSave = () => {
    const data = {
      roleID: state.roleID,
      scopeIDs: checkedKeys,
    };
    post("api/v1/users/savepermissions", data)
      .then((resp) => {
        showSuccess("Permissions have been saved successfully.");
      })
      .catch((err) => {
        showError(err);
      });
  };

  useEffect(() => {
    get("api/v1/users/getrolepermissions", { roleID: state.roleID })
      .then((resp) => {
        const { keys, permissions } = resp;
        setData(permissions);
        setCheckedKeys(keys);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {state?.isSystem && (
        <Alert
          message="You can not change any permission of Administrator role"
          type="warning"
          closable
        />
      )}
      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        Permissions of <strong>{state.roleName}</strong> role
      </div>
      <Tree
        key="key"
        checkable
        selectable={false}
        checkedKeys={checkedKeys}
        onCheck={onCheck}
        treeData={data}
      />
      <div style={{ marginTop: "10px" }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            onClick={onSave}
            disabled={state?.isSystem}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => {
              navigate("/security/roles");
            }}
          >
            Cancel
          </Button>
        </Space>
      </div>
    </div>
  );
};
export default Permissions;
